(ns hai.component-library
  "Developer-only gallery of reusable UI + layout primitives.

   Reachable from the admin/dev menu section (see `hai.web-app.layout`). Use it
   as a living reference when building pages: every block below renders a real
   component so you can eyeball variants and copy the hiccup."
  {:ornament/prefix "cl-"}
  #?(:cljs (:require-macros hai.component-library))
  #?(:cljs
      (:require
       [hai-model.model :as model]
       [hai.ui.components.form.core :as form]
       [hai.ui.components.form.select.components :as select.components]
       [hai.ui.components.form.select.searchable-multi-select :as searchable-select]
       [hai.ui.icons :as icons]
       [hai.ui.rf-sugar :refer [<s]]
       [hai.ui.tokens :as t]
       [hai.web-app.layout :as layout]
       [lambdaisland.ornament :as o])
     :clj
     (:require
      [hai-model.model :as model]
      [hai.ui.components.spinners :as spinners]
      [hai.ui.icons :as icons]
      [hai.ui.rf-sugar :refer [<s]]
      [hai.ui.tokens :as t]
      [hai.web-app.layout :as layout]
      [lambdaisland.ornament :as o])))

(o/defstyled section :section
  :flex :flex-col
  {:gap "16px"
   :padding "24px 0"
   :border-top (str "1px solid " t/--text-secondary-30)}
  [:>.title
   {:font-size "13px"
    :font-weight "600"
    :text-transform "uppercase"
    :letter-spacing "0.04em"
    :color t/--text-secondary-50}]
  [:>.row :flex :flex-wrap :items-center
   {:gap "12px"}]
  ([{:keys [title]} & children]
   (into [:<> [:div.title title]] children)))

(o/defstyled collection-based-searchable-multi-select :div
  [:pre {:display "inline"}]
  ([]
   [:<>
    [:h3 "Search resolver with " [:pre ":user.entity/legacy"] "filter set to " [:pre "true"]]
    [:h4 "User legacy setting: " [:pre (str @(<s :auth/legacy?))]]
    [:p "If user legacy setting is " [:pre "false"] " this will still return legacy entities"]
    #?(:cljs
       [form/component
        {:form/id :collection-based-searchable-multi-select
         :form/schema [:map [:assistant :any]]
         :form/render (fn [{{:keys [assistant]} :form/fields}]
                        [searchable-select/field
                         (assoc assistant
                                :query '[({:user/search [{:collection/items
                                                          {:prompt [:ai-prompt/uuid
                                                                    :ai-prompt/title
                                                                    :ai-prompt/content]
                                                           :assistant [:ai-model-config/uuid
                                                                       :ai-model-config/title]
                                                           :mini-app [:mini-app/uuid
                                                                      :mini-app/title
                                                                      :mini-app/description
                                                                      :mini-app/tool]
                                                           :contact [:contact/uuid
                                                                     :contact/full-name]
                                                           :note [:note/uuid
                                                                  :note/text]
                                                           :task [:task/uuid
                                                                  :task/title]}}]}
                                          ;; NOTE takes precedence over user setting 
                                          {:filters {:user.entity/legacy true}})]
                                :render {:style select.components/radix
                                         :label (fn [entity]
                                                  (str (model/->name entity)))})])}])]))

(defn page
  [_route]
  [layout/page
   [layout/lead "Developer-only reference of reusable UI and layout components."]
   [layout/content
    [collection-based-searchable-multi-select]
    ;; #_ #?(:cljs [universal-bar/trigger])
    ;; [spinners/pulse-dots]
    ]])

(defn routes []
  [["/component-library"
    {;; fully-qualified rather than ::routing/window-title to avoid wiring the
     ;; alias into this .cljc's reader-conditional requires; same keyword value.
     :hai.web-app.routing/window-title "Component library"
     :label "Component library"
     :icon icons/outlined-web}
    [""
     {:name :component-library/view
      :view page}]]])
